import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DashboardContext = createContext();

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error('useDashboard must be used within DashboardProvider');
  }
  return context;
};

export const DashboardProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [marketData, setMarketData] = useState([]);
  const [trackRecord, setTrackRecord] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchConfig = async () => {
    try {
      const response = await axios.get(`${API}/dashboard/config`);
      setConfig(response.data);
    } catch (error) {
      console.error('Failed to fetch config:', error);
    }
  };

  const fetchMarketData = async () => {
    try {
      const response = await axios.get(`${API}/dashboard/market-data`);
      setMarketData(response.data);
    } catch (error) {
      console.error('Failed to fetch market data:', error);
    }
  };

  const fetchTrackRecord = async () => {
    try {
      const response = await axios.get(`${API}/track-record`);
      setTrackRecord(response.data);
    } catch (error) {
      console.error('Failed to fetch track record:', error);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      await Promise.all([fetchConfig(), fetchMarketData(), fetchTrackRecord()]);
      setLoading(false);
    };
    initialize();

    // Update market data every 15 minutes
    const interval = setInterval(fetchMarketData, 15 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const updateField = async (field, value) => {
    try {
      await axios.put(`${API}/admin/update-field`, { field, value });
      setConfig((prev) => ({ ...prev, [field]: value }));
    } catch (error) {
      console.error('Failed to update field:', error);
    }
  };

  return (
    <DashboardContext.Provider value={{ config, marketData, trackRecord, loading, updateField, fetchConfig, fetchMarketData, fetchTrackRecord }}>
      {children}
    </DashboardContext.Provider>
  );
};